import navBarHomepage from '../modules/navbar-homepage';

let authorController = () => {
    navBarHomepage.on();
};

export default authorController;
